<template>
<div>
    <h1 class="text-h5 my-5">
        Inspection configs
        <v-progress-circular v-if="loading" indeterminate color="green" class="ml-2"/>
    </h1>
    <v-alert v-if="alert.msg" :color="alert.color" icon="mdi-alert-octagon-outline" outlined text dismissible>
        {{alert.msg}}
    </v-alert>

    <v-simple-table>
        <thead>
        <tr>
            <th>Inspection</th>
            <th><span class="text-no-wrap">Workspace-level</span> override</th>
            <th><span class="text-no-wrap">Project-level</span> overrides</th>
            <th><span class="text-no-wrap">Application-level</span> overrides</th>
        </tr>
        </thead>
        <tbody>
            <tr v-for="i in inspections">
                <td>
                    {{ i.title }}
                    <div class="grey--text text-no-wrap">
                        Condition: {{ formatCondition(i) }}
                    </div>
                </td>
                <td>
                    <template v-if="slo(i)">&mdash;</template>
                    <a v-else @click="openForm(i, '', '', '')">
                        <template v-if="i.workspace_override.config">{{formatThreshold(i, i.workspace_override.config)}}</template>
                        <v-icon v-else small>mdi-file-replace-outline</v-icon>
                    </a>
                </td>
                <td>
                    <template v-if="slo(i)">&mdash;</template>
                    <div v-else v-for="o in i.project_overrides" class="text-no-wrap">
                        {{o.project_name}}:
                        <a @click="openForm(i, o.project_id, o.project_name, '')">{{formatThreshold(i, o.config)}}</a>
                    </div>
                </td>
                <td>
                    <div v-for="o in i.application_overrides" class="text-no-wrap">
                        {{o.project_name}}/{{$utils.appId(o.application_id).name}}:
                        <a @click="openForm(i, o.project_id, o.project_name, o.application_id)">
                            {{formatThreshold(i, o.config)}}
                        </a>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-simple-table>

    <InspectionForm v-model="form.open" :inspection_id="form.inspection_id" :project_id="form.project_id" :project_name="form.project_name" :application_id="form.application_id" />
</div>
</template>

<script>
import InspectionForm from "@/pages/console/InspectionForm.vue";

export default {
    props: {
        workspaceId: String,
    },

    components: {InspectionForm},

    data() {
        return {
            access: '',
            loading: false,
            alert: {msg: '', color: ''},
            inspections: [],

            form: {
                open: false,
                inspection_id: null,
                project_id: '',
                project_name: '',
                application_id: '',
            },
        };
    },

    computed: {
        canEdit() {
            return this.access === 'edit';
        },
    },

    mounted() {
        this.get();
    },

    watch: {
        'form.open'(v) {
            !v && this.get();
        }
    },

    methods: {
        slo(i) {
            return i.id.startsWith('SLO');
        },
        formatValue(value, unit) {
            if (unit === 'second') {
                return value < 1 ? value*1000+'ms' : value+'s';
            }
            if (unit === 'percent') {
                return value+'%';
            }
            return value+unit;
        },
        formatCondition(inspection) {
            const condition = inspection.condition.replaceAll('<threshold>', this.formatValue(inspection.threshold, inspection.unit))
            if (inspection.id === 'SLOLatency') {
                return condition.replace('<bucket>', '500ms');
            }
            return condition;
        },
        formatThreshold(inspection, config) {
            if (inspection.id === 'SLOAvailability') {
                return this.formatValue(config[0].objective_percentage, 'percent');
            }
            if (inspection.id === 'SLOLatency') {
                return this.formatValue(config[0].objective_percentage, 'percent') + ' < ' + this.formatValue(config[0].objective_bucket, 'second');
            }
            return this.formatValue(config.threshold, inspection.unit);
        },
        openForm(inspection, project_id, project_name, application_id) {
            if (!this.canEdit) {
                return;
            }
            this.form.open = true;
            this.form.inspection_id = inspection.id;
            this.form.project_id = project_id;
            this.form.project_name = project_name;
            this.form.application_id = application_id;
        },
        get() {
            this.loading = true;
            this.$api.getInspections((data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.alert.msg = 'Failed to get inspections. Please try again later.'
                    this.alert.color = 'red';
                }
                this.access = data.access;
                this.inspections = data.inspections || [];
                if (!this.canEdit) {
                    this.alert.msg = 'You are not allowed to configure inspections.'
                    this.alert.color = 'primary';
                }
            });
        },

    },
}
</script>

<style scoped>

</style>